/* Tiixo 2026 — product page: variants, gallery, lightbox, sticky add to cart */
(function () {
  'use strict';
  function boot() {
    var root = document.querySelector('[data-tx-pdp]');
    if (!root || root._tx) return;
    root._tx = true;
    var TX = window.TX;
    var $ = function (s, r) { return (r || root).querySelector(s); };
    var $$ = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };
    var data = JSON.parse($('[data-tx-product-json]').textContent);
    var money = TX.formatMoney;

    /* ---------- gallery ---------- */
    var track = $('[data-tx-gal-track]');
    var slides = track ? $$('.tx-gal__slide', track) : [];
    var thumbs = $$('.tx-gal__thumb');
    var counter = $('[data-tx-gal-i]');
    var dotsWrap = $('[data-tx-dots]'), dots = dotsWrap ? dotsWrap.firstElementChild : null;
    if (dotsWrap && dots && dots.children.length > 7) dotsWrap.style.width = (7 * 14) + 'px';
    var idx = 0;
    /* frame takes the active photo's own shape: never crops words, no white bars */
    function fitH() {
      if (!track || !slides.length) return;
      track.classList.add('is-fit');
      var h = slides[Math.min(idx, slides.length - 1)].offsetHeight;
      if (h) track.style.height = h + 'px';
    }
    fitH();
    window.addEventListener('resize', fitH);
    function go(i, smooth) {
      if (!slides.length) return;
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
    }
    function setActive(i) {
      idx = i;
      fitH();
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      if (counter) counter.textContent = i + 1;
      if (dots) {
        var ds = dots.children, n = ds.length, D = 14, show = 7;
        for (var k = 0; k < n; k++) {
          var dist = Math.abs(k - i);
          ds[k].className = k === i ? 'is-on' : (n > show && dist >= 3 ? (dist === 3 ? 'is-sm' : 'is-xs') : '');
        }
        if (n > show) {
          var first = Math.max(0, Math.min(i - 3, n - show));
          dots.style.transform = 'translateX(' + (-first * D) + 'px)';
        }
      }
      var a = thumbs[i];
      if (a && a.parentElement.scrollHeight > a.parentElement.clientHeight) {
        var p = a.parentElement, top = a.offsetTop - p.clientHeight / 2 + a.clientHeight / 2;
        p.scrollTo({ top: top, behavior: 'smooth' });
      }
    }
    if (track) {
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () { setActive(Math.round(track.scrollLeft / track.clientWidth)); });
      }, { passive: true });
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
      var pv = $('[data-tx-gal-prev]'), nx = $('[data-tx-gal-next]');
      if (pv) pv.addEventListener('click', function () { go(idx - 1); });
      if (nx) nx.addEventListener('click', function () { go(idx + 1); });
    }
    function goMedia(id) {
      if (!id) return;
      for (var i = 0; i < slides.length; i++) { if (String(slides[i].getAttribute('data-media-id')) === String(id)) { go(i); return; } }
    }

    /* ---------- lightbox ---------- */
    var lb = $('[data-tx-lightbox]'), lbImg = $('[data-tx-lb-img]');
    var imgs = data.media.filter(function (m) { return m.src; });
    var lbi = 0;
    function lbShow(i) {
      lbi = (i + imgs.length) % imgs.length;
      lbImg.src = imgs[lbi].src;
    }
    root.addEventListener('click', function (e) {
      var z = e.target.closest('[data-tx-zoom]');
      if (z && lb) {
        var sid = z.closest('.tx-gal__slide').getAttribute('data-media-id');
        var k = 0; imgs.forEach(function (m, j) { if (String(m.id) === sid) k = j; });
        lbShow(k); lb.hidden = false; document.documentElement.style.overflow = 'hidden';
      }
    });
    if (lb) {
      var lbClose = function () { lb.hidden = true; document.documentElement.style.overflow = ''; };
      $('[data-tx-lb-close]').addEventListener('click', lbClose);
      lb.addEventListener('click', function (e) { if (e.target === lb || e.target === lbImg) lbClose(); });
      $('[data-tx-lb-prev]').addEventListener('click', function (e) { e.stopPropagation(); lbShow(lbi - 1); });
      $('[data-tx-lb-next]').addEventListener('click', function (e) { e.stopPropagation(); lbShow(lbi + 1); });
      document.addEventListener('keydown', function (e) {
        if (lb.hidden) return;
        if (e.key === 'Escape') lbClose();
        if (e.key === 'ArrowLeft') lbShow(lbi - 1);
        if (e.key === 'ArrowRight') lbShow(lbi + 1);
      });
    }

    /* ---------- quantity ---------- */
    var qtyIn = $('[data-tx-qty-input]');
    $$('[data-tx-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        qtyIn.value = Math.max(1, (Number(qtyIn.value) || 1) + Number(b.getAttribute('data-tx-step')));
        updBuyNow();
      });
    });
    if (qtyIn) qtyIn.addEventListener('change', updBuyNow);

    /* ---------- holiday offers: How many? cards set the quantity (Pair 10% / Set 15% come off as Shopify automatic discounts) ---------- */
    var ofBox = $('[data-tx-offer]');
    var ofCards = ofBox ? $$('.tx-of__c', ofBox) : [];
    function ofSync() {
      if (!ofBox || !current) return;
      var on = null;
      ofCards.forEach(function (c) {
        var n = Number(c.getAttribute('data-n')), pct = Number(c.getAttribute('data-pct'));
        var each = current.price - Math.floor(current.price * pct / 100), full = current.price * n, pay = each * n; // matches Shopify: % off each unit, rounded down
        var b = c.querySelector('[data-of-pay]'); if (b) b.textContent = money(pay);
        var f = c.querySelector('[data-of-full]'); if (f) f.textContent = money(full);
        var e = c.querySelector('[data-of-each]'); if (e) e.textContent = money(each);
        if (c.classList.contains('is-on')) on = { n: n, pay: pay };
      });
      if (!on) return;
      if (qtyIn) qtyIn.value = on.n;
      var ap = $('[data-tx-atc-price]'); if (ap) ap.textContent = money(on.pay);
      if (current.available) {
        var l = $('[data-tx-atc-label]'); if (l) l.textContent = on.n === 2 ? 'Add the pair' : on.n === 3 ? 'Add the set' : 'Add to cart';
      }
      updBuyNow();
    }
    ofCards.forEach(function (c) {
      c.addEventListener('click', function () {
        ofCards.forEach(function (x) { var y = x === c; x.classList.toggle('is-on', y); x.setAttribute('aria-checked', String(y)); });
        ofSync();
      });
    });
    var giftCb = $('[data-tx-gift-cb]');
    if (giftCb) giftCb.addEventListener('change', function () {
      var more = giftCb.closest('[data-tx-gift]').querySelector('.tx-gift__more');
      var ta = more.querySelector('textarea');
      more.hidden = !giftCb.checked; ta.disabled = !giftCb.checked;
      if (giftCb.checked) ta.focus();
    });

    /* ---------- Shop logo in the installments line: black instead of Shop purple (Shop's brand rules allow black). If Shopify changes its markup it simply stays purple. ---------- */
    (function () {
      var tries = 0;
      var t = setInterval(function () {
        var el = root.querySelector('shopify-payment-terms');
        var sr = el && el.shadowRoot;
        if (!sr && ++tries < 50) return;
        clearInterval(t);
        if (!sr) return;
        var add = function () {
          if (sr.querySelector('style[data-tx-shop]')) return;
          var s = document.createElement('style');
          s.setAttribute('data-tx-shop', '');
          s.textContent = '.text-purple-primary{color:#141414 !important}';
          sr.appendChild(s);
        };
        add();
        new MutationObserver(add).observe(sr, { childList: true });
      }, 200);
    })();

    /* ---------- installments box: a tap anywhere goes to Shop Pay checkout (the info button inside Shopify's line still opens its own popup) ---------- */
    var p4box = $('[data-tx-pay4]');
    if (p4box) p4box.addEventListener('click', function (e) {
      if (e.target.closest('a')) return;
      var path = e.composedPath ? e.composedPath() : [];
      for (var i = 0; i < path.length && path[i] !== p4box; i++) { if (path[i].tagName === 'BUTTON') return; }
      var go = p4box.querySelector('[data-tx-pay4-go]');
      if (go && !go.classList.contains('is-off')) window.location.href = go.href;
    });

    /* ---------- variants ---------- */
    var groups = $$('[data-tx-opt]');
    var idIn = $('[data-tx-variant-id]');
    var current = null;
    data.variants.forEach(function (x) { if (String(x.id) === String(idIn.value)) current = x; });

    function selected() {
      return groups.map(function (g) { var c = g.querySelector('input:checked'); return c ? c.value : null; });
    }
    function find(opts) {
      for (var i = 0; i < data.variants.length; i++) {
        var x = data.variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) { if (opts[j] !== null && x.options[j] !== opts[j]) { ok = false; break; } }
        if (ok) return x;
      }
      return null;
    }
    function markAvailability(opts) {
      groups.forEach(function (g, gi) {
        $$('input', g).forEach(function (inp) {
          var test = opts.slice(); test[gi] = inp.value;
          var any = data.variants.some(function (x) {
            for (var j = 0; j < test.length; j++) { if (test[j] !== null && x.options[j] !== test[j]) return false; }
            return x.available;
          });
          inp.closest('.tx-val').classList.toggle('is-oos', !any);
          var so = g.querySelector('select option[value="' + CSS.escape(inp.value) + '"]');
          if (so) so.textContent = inp.value + (any ? '' : ' — sold out');
        });
      });
    }
    function updBuyNow() {
      var a = $('[data-tx-buy-now]');
      var q = Math.max(1, Number(qtyIn && qtyIn.value) || 1);
      var p4 = $('[data-tx-pay4-go]');
      if (p4 && current) {
        p4.href = '/cart/' + current.id + ':' + q + '?payment=shop_pay' + (data.bf && data.autoApply ? '&discount=' + encodeURIComponent(data.code) : '');
        p4.classList.toggle('is-off', !current.available);
      }
      if (!a || !current) return;
      a.href = '/cart/' + current.id + ':' + q + (data.bf && data.autoApply ? '?discount=' + encodeURIComponent(data.code) : '');
      a.classList.toggle('is-off', !current.available);
    }
    function render(v) {
      current = v;
      var atcs = $$('[data-tx-atc]', document);
      if (!v) {
        atcs.forEach(function (b) { b.disabled = true; var l = b.querySelector('[data-tx-atc-label]'); if (l) l.textContent = 'Unavailable'; });
        return;
      }
      idIn.value = v.id;
      idIn.dispatchEvent(new Event('change', { bubbles: true })); // lets Shopify's Pay in 4 line re-price for this variant
      $$('[data-tx-price]', document).forEach(function (n) { n.textContent = money(v.price); });
      var cmp = $('[data-tx-compare]');
      if (cmp) { cmp.hidden = !(v.compare > v.price); cmp.textContent = money(v.compare); }
      var code = Math.round(v.price * data.keep / 100);
      $$('[data-tx-code-price]', document).forEach(function (n) { n.textContent = money(code); });
      var ap = $('[data-tx-atc-price]'); if (ap) ap.textContent = money(data.bf ? code : v.price);
      atcs.forEach(function (b) {
        b.disabled = !v.available;
        var l = b.querySelector('[data-tx-atc-label]'); if (l) l.textContent = v.available ? 'Add to cart' : 'Sold out';
      });
      var sep = $('.tx-buy__sep'); if (sep) { sep.hidden = !v.available; if (ap) ap.hidden = !v.available; }
      if (data.sale) {
        var has = v.compare > v.price, sv = v.compare - v.price, pc = has ? Math.floor(sv * 100 / v.compare) : 0;
        $$('[data-tx-sale]', document).forEach(function (n) { n.hidden = !has; });
        $$('[data-tx-save-amt]', document).forEach(function (n) { n.textContent = money(sv); });
        $$('[data-tx-save-pct]', document).forEach(function (n) { n.textContent = pc; });
        $$('[data-tx-compare-t]', document).forEach(function (n) { n.textContent = money(v.compare); });
      }
      var sku = $('[data-tx-sku]'); if (sku) sku.textContent = v.sku || '';
      var sv = $('[data-tx-satc-v]', document); if (sv) sv.textContent = v.title;
      groups.forEach(function (g, gi) {
        var l = g.querySelector('[data-tx-opt-label]'); if (l) l.textContent = v.options[gi];
        var sel = g.querySelector('[data-tx-opt-select]'); if (sel) sel.value = v.options[gi];
      });
      if (v.media) goMedia(v.media);
      updBuyNow();
      ofSync();
      var u = new URL(window.location.href);
      u.searchParams.set('variant', v.id);
      history.replaceState({}, '', u.toString());
    }
    groups.forEach(function (g) {
      var sel = g.querySelector('[data-tx-opt-select]');
      if (sel) sel.addEventListener('change', function () {
        var r = g.querySelector('input[value="' + CSS.escape(sel.value) + '"]'); if (r) r.checked = true;
      });
      g.addEventListener('change', function () {
        var opts = selected();
        var v = find(opts);
        if (!v || !v.available) {
          // keep the value just picked, then pick the closest available combination
          var gi = groups.indexOf(g), picked = opts[gi];
          var alt = data.variants.filter(function (x) { return x.options[gi] === picked && x.available; })[0]
            || data.variants.filter(function (x) { return x.options[gi] === picked; })[0];
          if (alt && alt !== v) {
            groups.forEach(function (gg, k) { var i = gg.querySelector('input[value="' + CSS.escape(alt.options[k]) + '"]'); if (i) i.checked = true; });
            v = alt; opts = alt.options.slice();
          }
        }
        markAvailability(opts);
        render(v);
      });
    });
    if (groups.length) markAvailability(selected());
    updBuyNow();
    ofSync();

    /* ---------- sticky add to cart ---------- */
    var satc = document.querySelector('[data-tx-sticky-atc]');
    var mainAtc = $('.tx-buy');
    if (satc && mainAtc && 'IntersectionObserver' in window) {
      var footer = document.querySelector('.tx-ft');
      var past = false, nearFoot = false;
      var upd = function () {
        var on = past && !nearFoot;
        satc.classList.toggle('is-on', on);
        satc.setAttribute('aria-hidden', String(!on));
        var fb = document.querySelector('[data-tx-fbar]'); if (fb && on) fb.classList.remove('is-on');
      };
      new IntersectionObserver(function (es) { es.forEach(function (e) { past = !e.isIntersecting && e.boundingClientRect.top < 0; upd(); }); }).observe(mainAtc);
      if (footer) new IntersectionObserver(function (es) { es.forEach(function (e) { nearFoot = e.isIntersecting; upd(); }); }).observe(footer);
    }

    /* recently viewed */
    try {
      var rv = JSON.parse(localStorage.getItem('tx-rv') || '[]').filter(function (h) { return h !== location.pathname.split('/').pop(); });
      rv.unshift(location.pathname.split('/').pop()); localStorage.setItem('tx-rv', JSON.stringify(rv.slice(0, 12)));
    } catch (e) {}
  }
  if (window.TX && window.TX.formatMoney) boot();
  else document.addEventListener('tx:ready', boot);
  document.addEventListener('DOMContentLoaded', function () { if (window.TX && window.TX.formatMoney) boot(); });
})();
